/**
 * Quotation Polling Configuration
 * 
 * Configuration for quotation job polling behavior.
 * All actual API calls go through the backend proxy at /api/quotation/*
 */

/**
 * Quotation polling configuration
 */
export const QUOTATION_POLLING_CONFIG = {
  defaultTimeout: 30000, // 30 seconds
  pollingInterval: 500,   // Poll every 0.5 seconds (2x per second)
  maxPollingAttempts: 60  // Max 30 seconds of polling
} as const;

